import { Avatar, Button, Dropdown, Input, Menu, message, Modal, Popconfirm, Spin } from "antd";
import * as AUTH_SERVICES from "api/services/auth/auth.services";
import { calculateTimeDifference, StatusCode, UserRoles } from 'common/enums';
import { FC, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setIsReservationsUpdated } from 'store/app/appSlice';
import { openProfileDetailsDrawer, setProfileDetailsID, setProfileDetailsType } from 'store/auth/authSlice';
import ClockIcon from "../../../../assets/images/app/clock_icon.svg";
import CancelIcon from "../../../../assets/images/app/i_icon.svg";
import Organnism from "../../../../assets/images/app/iam_organism.svg";
import Students from "../../../../assets/images/app/iam_student.svg";
import MoreOptions from "../../../../assets/images/app/options_icon.svg";
import s from "../calendar.module.css";
import TeacherCalendarForOrganism from "../calendarTeacher";

type Props = {
  course: any;
  isHistorique: boolean;
  teacher: any;
  displayClasseName: boolean;
};

const CardReservations: FC<Props> = ({ course, isHistorique, teacher, displayClasseName }) => {

  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [popconfirmVisible, setPopconfirmVisible] = useState(false);
  const [showDrawerTeacherCalendar, setShowDrawerTeacherCalendar] = useState<boolean>(false);
  const [isZoomMeetingVisible, setIsZoomMeetingVisible] = useState(false);
  const [currentMeetingId, setCurrentMeetingId] = useState('');

  const [isLoadingData, setIsLoadingData] = useState<boolean>(false);
  const [teacherData, setTeacherData] = useState<any>();

  const isStudent = user?.roles?.includes(UserRoles.STUDENT);
  const isTeacher = user?.roles?.includes(UserRoles.TEACHER);

  const courseDate = new Date(course?.startDate);

  // Add 1 days to the course date
  const limitDate = new Date(courseDate);
  limitDate.setDate(limitDate.getDate() + 1);

  // Optional: make it end of that day (23:59)
  limitDate.setHours(23, 59, 59, 999);

  // Check if now is after that limit
  const isPast = new Date() > limitDate;

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1050);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 1050);
  };
  window.addEventListener('resize', handleResize);

  const [openMobileModal, setOpenMobileModal] = useState(false);

  const handleMenuClick = (e: any) => {
    if (e.key === "0") {
      if (isMobile) {
        e.preventDefault();
        setOpenMobileModal(true);
      } else {
        if (course?.commonLink) {
          window.open(course.commonLink, "_blank", "noopener,noreferrer");
        }
      }
    }
    else if (e.key === "1") {
      setPopconfirmVisible(true);
      setDropdownVisible(false);
    }
    else if (e.key === "2") {
      setDropdownVisible(false);
      setIsLoadingData(true);
      checkScheduleMeeting();
    }
  };

  const handleConfirm = () => {
    setPopconfirmVisible(false);
    setIsLoadingData(false);
    ///checkCancelMeeting();
    setIsCancelModalOpen(true);
  };

  const handleCancel = () => {
    setPopconfirmVisible(false);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);
  const [isScheduleMessageModalOpen, setIsScheduleMessageModalOpen] = useState(false);
  const [cancelMessage, setCancelMessage] = useState("");
  const [scheduleMessage, setScheduleMessage] = useState("");

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancelModal = () => {
    setIsModalOpen(false);
  };

  const handleCancelScheduleModal = () => {
    setIsScheduleModalOpen(false);
  };

  const handleCancelMeetModal = () => {
    setIsCancelModalOpen(false);
  };

  const handleCancelScheduleMessageModal = () => {
    setIsScheduleMessageModalOpen(false);
  };

  const handleScheduleMeeting = () => {
    setIsModalOpen(false);
    setIsLoadingData(true);
    checkScheduleMeeting();
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="0" disabled={!course?.commonLink}>Rejoindre le meet</Menu.Item>
      <Menu.Item key="1">Annuler le meet</Menu.Item>
      {course?.codeCoupon?.couponType !== "FREE_CLASS" && <Menu.Item key="2">Replanifier le meet</Menu.Item>}
    </Menu>
  );

  const cancelMeeting = async () => {
    setIsLoading(true);
    try {
      if (cancelMessage !== "") {
        const response = await AUTH_SERVICES.cancelMeetingOrganism(course?._id, teacher ? teacher?._id : course?.profId?._id, cancelMessage);
        if (response?.statusCode === StatusCode.OK) {
          message.success({
            content: "Meet annulé ",
          });
          setTimeout(() => {
            dispatch(setIsReservationsUpdated(true));
          }, 2000);
          setIsLoading(false);
          setIsModalOpen(false);
        }
        else {
          message.warning({
            content: "Ooops, erreur lors de l'annulation",
          });
          setIsLoading(false);
        }
      }
      else {
        message.warning({
          content: "Ooops, entre le message de l'annulation",
        });
        setIsLoading(false);
      }
    } catch (error: any) {
      message.warning({
        content: error?.response?.data?.message,
      });
      setIsLoading(false);
    }
  }

  const sendScheduleMeetingMessage = async () => {
    localStorage.setItem("scheduleMessage", scheduleMessage);
    localStorage.setItem("level", course?.level?._id);
    setIsLoading(false);
    setIsScheduleMessageModalOpen(false);
    getTeacherData(course?.profId?._id);
  }

  const getTeacherData = async (teacherId: string) => {
    setIsScheduleModalOpen(false);
    setIsLoadingData(true);
    try {
      const response = await AUTH_SERVICES.getTeacherData(user?._id, teacherId);
      setTeacherData(response?.data);

      setTimeout(() => {
        setIsLoadingData(false);
        setIsModalOpen(false);
        setShowDrawerTeacherCalendar(true);
      }, 2000);
    } catch (error: any) {
      setIsLoadingData(false);
    }
  };

  const handleProfileDetails = () => {
    dispatch(setProfileDetailsID(teacher?.uid));
    dispatch(setProfileDetailsType("teacher"));
    dispatch(openProfileDetailsDrawer());
  }

  const checkScheduleMeeting = async () => {
    setIsLoading(true);
    try {
      const response = await AUTH_SERVICES.checkScheduleMeeting(user?._id, course?._id);
      if (response?.statusCode === StatusCode.OK) {
        if (response?.data) {
          setIsScheduleModalOpen(true);
          setIsLoadingData(false);
        }
        else {
          localStorage.setItem("level", course?.level?._id);
          getTeacherData(course?.profId?._id);
        }
      }
      else {
        message.warning({
          content: response?.data?.message,
        });
      }
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Erreur interne du serveur. Veuillez réessayer plus tard.";

      message.warning({
        content: errorMessage,
      });
    }
    finally {
      setIsLoading(false);
    }
  }

  const checkCancelMeeting = async () => {
    setIsLoading(true);
    try {
      const response = await AUTH_SERVICES.checkCancelMeeting(user?._id, course?._id);
      if (response?.statusCode === StatusCode.OK) {
        if (response?.data) {
          setIsCancelModalOpen(true);
          setIsLoadingData(false);
        }
        else {
          setIsCancelModalOpen(false);
          setIsLoadingData(false);
          showModal();
        }
      }
      else {
        message.warning({
          content: response?.data?.message,
        });
      }
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Erreur interne du serveur. Veuillez réessayer plus tard.";

      message.warning({
        content: errorMessage,
      });
    }
    finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <div className={`${course?.status === "CANCELED" ? s.classeCardDeleted : course?.codeCoupon ? s.classeCardCoupon : s.classeCard}`}>
        <div className={course?.codeCoupon ? s.cardClassBoxCoupon : s.cardClassBox}>
          <div className={s.avatarNameBox} onClick={handleProfileDetails}>
            <Avatar.Group
              maxCount={3}
              maxStyle={{
                color: "#f56a00",
                backgroundColor: "#fde3cf",
              }}
              style={{ marginRight: isMobile ? "0px" : "5px", cursor: "pointer" }}
            >
              <Avatar
                size={45}
                style={{ backgroundColor: "#FFF2E0", boxShadow: "0px 3px 6px #00000029" }}
                src={isTeacher ? Students : teacher?.profile || course?.profId?.profile}
              />
            </Avatar.Group>
            <div style={{ position: "relative", left: isMobile ? "0px" : "5px", fontSize: isMobile ? "0.8em" : "13px", textTransform: "capitalize", cursor: "pointer" }}>{isTeacher ? "Cours collectif" : teacher ? teacher?.firstname + " " + teacher?.lastname : course?.profId?.firstname + " " + course?.profId?.lastname}</div>
          </div>

          <div className={s.detailsBox}>
            <div className={s.timeBox}>
              {!isMobile && <img src={ClockIcon} height={15} style={{ marginRight: "10px" }}></img>}
              <div className={s.times}>
                <span className={s.time}>{isMobile && <img src={ClockIcon} height={10} style={{ marginRight: "5px" }}></img>} De {course?.range[0]} à {course?.range[course?.range?.length - 1]}</span>
                <span className={s.timeDescription}>Séance de “{calculateTimeDifference(course?.range[0], course?.range[course?.range.length - 1])}”</span>
              </div>
            </div>

            <div className={s.amountBox}>
              <div className={s.priceBox}>{course?.pricePerStudent} {course?.pricePerStudent >= 2 ? "Crédits" : "Crédit"}</div>
              {/* {!isStudent && !isTeacher && <div style={{ marginLeft: "10px", marginRight: "10px", height: "35px", width: "1px", background: "#707070" }}></div>} */}
              {/* {!isStudent && !isTeacher && <img src={CheckIcon} height={20} />} */}
              {/* {!isStudent && !isTeacher && <span style={{ width: "auto", fontWeight: "600" }}>Réservation confirmée<br /> chez les élèves</span>} */}
              {/* <a href={course?.commonLink} target="_blank"><Button className={s.meetButton}>
                <img src={MeetIcon} height={isMobile ? 14 : 18} style={{ marginLeft: isMobile ? "0px" : "5px" }}></img>
              </Button></a> */}
            </div>

            {displayClasseName && course?.title && <div style={{ marginLeft: "10px", height: 35, background: "#FFF", borderRadius: "12px", border: "1px dashed #707070", display: "flex", alignItems: "center", justifyContent: "center", paddingLeft: "5px", paddingRight: "5px" }}>{course?.title}</div>}
          </div>

          {isLoading || isLoadingData ? <div>
            <Spin />
          </div> : !isStudent && !isTeacher && course?.status === "BOOKED" && <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
            {course?.status === "BOOKED" && <Dropdown overlay={menu} visible={isPast ? false : dropdownVisible} onVisibleChange={setDropdownVisible} overlayStyle={{ border: "none" }}>
              <Button disabled={isPast} onClick={() => setDropdownVisible(true)} className={isPast ? s.disabledMeetButton : s.meetButton}>
                <img src={MoreOptions} height={isMobile ? 14 : 18} style={{ marginRight: 10 }}></img>
                Options
              </Button>
            </Dropdown>}
            {!isMobile && course?.status === "BOOKED" && <Popconfirm
              title={`Veux-tu annuler ce meet?`}
              visible={popconfirmVisible}
              onVisibleChange={(visible) => {
                if (!isLoading) {
                  setPopconfirmVisible(visible);
                }
              }}
              onConfirm={handleConfirm}
              onCancel={handleCancel}
              okText="Oui"
              cancelText="Non"
            >
              <Button type="primary" />
            </Popconfirm>}
            {course?.status === "CANCELED" && <div className={s.cancelBox}>
              <div className={s.horizontalLineDeleted}></div>
              <span>
                <img src={CancelIcon} height={isMobile ? 10 : 18} style={{ marginRight: "5px", marginLeft: isMobile ? "0px" : "20px" }}></img>
                Meet annulé
              </span>
            </div>}
          </div>}
        </div>
      </div>

      {isMobile && <Popconfirm
        title={`Veux-tu annuler ce meet?`}
        visible={popconfirmVisible}
        onVisibleChange={(visible) => {
          if (!isLoading) {
            setPopconfirmVisible(visible);
          }
        }}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        okText="Oui"
        cancelText="Non"
      >
        <Button type="primary" />
      </Popconfirm>}

      <Modal
        visible={openMobileModal}
        onCancel={() => setOpenMobileModal(false)}
        footer={null}
        centered
      >
        <div style={{ textAlign: "center", padding: "10px" }}>
          <h3 style={{ marginBottom: "10px" }}>
            ⚠️ Accès non disponible sur mobile
          </h3>

          <p style={{ color: "#665" }}>
            Vous ne pouvez pas participer à ce cours depuis votre téléphone.
            <br />
            Merci d'utiliser un ordinateur.
          </p>

          <Button
            type="primary"
            style={{ marginTop: "15px" }}
            onClick={() => setOpenMobileModal(false)}
          >
            OK
          </Button>
        </div>
      </Modal>

      {/* ScheduleMeeting */}
      <TeacherCalendarForOrganism
        open={showDrawerTeacherCalendar}
        setOpen={setShowDrawerTeacherCalendar}
        currentTeacher={teacher ? teacher : course?.profId}
        currentReservation={course}
        classroomId={course?.classeId}
        onClose={() => { }}
      />

      {/* Cancel Meet */}
      <Modal
        title={null}
        visible={isCancelModalOpen}
        onCancel={handleCancelMeetModal}
        footer={null}
        centered={true}
        closable={false}
      >
        <div style={{
          border: '1px solid #000',
          borderRadius: 8,
          padding: 16,
          backgroundColor: '#FFF'
        }}>
          <p style={{ marginBottom: 24 }}>
            <strong>Attention :</strong> Ce cours sera annulé.
            <br />
            Es-tu sûr(e) de vouloir continuer la démarche d'annulation ?
          </p>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <Button className={s.scheduleButton} loading={isLoadingData} onClick={() => setIsCancelModalOpen(false)}>
              Non, revenir
            </Button>
            <Button className={s.cancelButton} loading={isLoading || isLoadingData} onClick={() => { setIsCancelModalOpen(false); setIsModalOpen(true) }}>
              Oui, continuer
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        title={
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start" }}>
            <Avatar.Group
              maxCount={3}
              maxStyle={{
                color: "#f56a00",
                backgroundColor: "#fde3cf",
              }}
              style={{ marginRight: "5px" }}
            >
              <Avatar
                size={45}
                style={{ backgroundColor: "#FFF2E0", boxShadow: "0px 3px 6px #00000029" }}
                src={user?.profile || Organnism}
              />
            </Avatar.Group>
            Annulation de meet
          </div>
        }
        visible={isModalOpen}
        onCancel={handleCancelModal}
        footer={null}
      >
        <div style={{ marginBottom: "16px", textTransform: "capitalize" }}>
          <strong>
            {new Intl.DateTimeFormat("fr-FR", {
              weekday: "long",
              day: "numeric",
              month: "long",
              year: "numeric",
            }).format(new Date(course?.day))}
          </strong>
        </div>
        <div style={{ marginBottom: "8px" }}>
          <span>Message pour {teacher?.firstname}</span>
        </div>
        <Input.TextArea
          rows={3}
          placeholder="J'annule le meet parce que..."
          value={cancelMessage}
          onChange={(e) => setCancelMessage(e.target.value)}
          style={{ borderRadius: "10px" }}
          required={true}
        />
        <div
          style={{
            marginTop: "24px",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: isMobile ? "center" : "space-between",
          }}
        >
          <Button className={s.scheduleButton} loading={isLoadingData} onClick={handleScheduleMeeting}>
            Reprogrammer plutôt
          </Button>
          <Button className={s.cancelButton} loading={isLoading || isLoadingData} onClick={cancelMeeting}>
            Confirmer l'annulation
          </Button>
        </div>
      </Modal>

      {/* Schedule */}
      <Modal
        title={null}
        visible={isScheduleModalOpen}
        onCancel={handleCancelScheduleModal}
        footer={null}
        centered={true}
        closable={false}
      >
        <div style={{
          border: '1px solid #000',
          borderRadius: 8,
          padding: 16,
          backgroundColor: '#FFF'
        }}>
          <p style={{ marginBottom: 24 }}>
            <strong>Attention :</strong> Ce cours sera reprogrammé.
            <br />
            Es-tu sûr de vouloir continuer la démarche de reprogrammation ?
          </p>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <Button className={s.scheduleButton} loading={isLoadingData} onClick={() => setIsScheduleModalOpen(false)}>
              Non, revenir
            </Button>
            <Button className={s.cancelButton} loading={isLoading || isLoadingData} onClick={() => { setIsScheduleModalOpen(false); setIsScheduleMessageModalOpen(true) }}>
              Oui, continuer
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        title={
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start" }}>
            <Avatar.Group
              maxCount={3}
              maxStyle={{
                color: "#f56a00",
                backgroundColor: "#fde3cf",
              }}
              style={{ marginRight: "5px" }}
            >
              <Avatar
                size={45}
                style={{ backgroundColor: "#FFF2E0", boxShadow: "0px 3px 6px #00000029" }}
                src={user?.profile}
              />
            </Avatar.Group>
            Reprogrammation de meet
          </div>
        }
        visible={isScheduleMessageModalOpen}
        onCancel={handleCancelScheduleMessageModal}
        footer={null}
      >
        <div style={{ marginBottom: "16px", textTransform: "capitalize" }}>
          <strong>
            {new Intl.DateTimeFormat("fr-FR", {
              weekday: "long",
              day: "numeric",
              month: "long",
              year: "numeric",
            }).format(new Date(course?.day))}
          </strong>
        </div>
        <div style={{ marginBottom: "8px" }}>
          <span>Motif de la reprogrammation</span>
        </div>
        <Input.TextArea
          rows={3}
          placeholder="Je reprogramme le meet parce que..."
          value={scheduleMessage}
          onChange={(e) => setScheduleMessage(e.target.value)}
          style={{ borderRadius: "10px" }}
          required={true}
        />
        <div
          style={{
            marginTop: "24px",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: isMobile ? "center" : "space-between",
          }}
        >
          <Button className={s.scheduleButton} loading={isLoadingData} onClick={() => setIsScheduleMessageModalOpen(false)}>
            Annuler
          </Button>
          <Button className={s.cancelButton} loading={isLoading || isLoadingData} onClick={() => sendScheduleMeetingMessage()}>
            Confirmer
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default CardReservations;
